var FlightBoardWidget = (function ($) {
    FlightBoardWidget = function (options) {
        var that = this;

        // DOM
        that.$wrapper = options["$wrapper"];
        that.$list_items = that.$wrapper.find('.js-list-item');

        that.$load_more_wrapper = that.$wrapper.find('.js-load-more-wrapper');
        that.$load_more = that.$load_more_wrapper.find('.js-load-more');

        // CONST
        that.next_page_count = options["next_page_count"];
        that.count_of_remaining = options["count_of_remaining"];

        // DYNAMIC VARS
        that.actual_elements = that.next_page_count;

        // INIT
        that.init();
    };

    FlightBoardWidget.prototype.init = function () {
        var that = this;

        that.initPagination();
        that.initNextButton();
    };

    FlightBoardWidget.prototype.initPagination = function () {
        var that = this;

        if (that.actual_elements < that.count_of_remaining) {
            that.$load_more_wrapper.show();
        } else {
            that.$load_more_wrapper.hide();
        }
    };

    FlightBoardWidget.prototype.initNextButton = function () {
        var that = this;

        that.$load_more.on('click', function () {
            that.$list_items.slice(that.actual_elements, that.actual_elements + that.next_page_count).show();

            that.actual_elements += that.next_page_count;
            that.initPagination();
        });
    };

    return FlightBoardWidget;
})($);
